import React,{useEffect, useRef } from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import { amber, green, brown, blue } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import WarningIcon from '@material-ui/icons/Warning';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import CodeIcon from '@material-ui/icons/Code';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
  debug: CodeIcon
};

// How long a notification stays up, per variant. 0 = until the user closes it:
// an error names something the user has to react to, so it must not scroll past
// while they are looking elsewhere. Sugar's own toastr keeps errors the same way.
const AUTO_HIDE_MS = {
  success: 5000,
  info: 5000,
  debug: 5000,
  warning: 15000,
  error: 0
};

const useStyles1 = makeStyles(theme => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: blue[700],
  },
  warning: {
    backgroundColor: amber[700],
  },
  debug: {
    backgroundColor: brown[700],
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  close: {
    padding: theme.spacing(0.5),
  },
  margin: {
    margin: theme.spacing(1),
    borderRadius : "5px"
  },
}));

export default function SnackbarContentWrapper(props) {
  const {message, variant } = props;  
  const classes = useStyles1();
  const Icon = variantIcon[variant] || InfoIcon;
  const timeout = AUTO_HIDE_MS[variant] !== undefined ? AUTO_HIDE_MS[variant] : 5000;

  // onClose is a new closure on every render of the parent. Kept in a ref so the
  // timer below can be set once per notification instead of restarting - or, worse,
  // piling up - on each render.
  const onCloseRef = useRef(props.onClose);
  onCloseRef.current = props.onClose;

  useEffect(() => {
    if (!timeout) {
      return undefined;
    }
    const timer = setTimeout(() => onCloseRef.current(), timeout);
    return () => clearTimeout(timer);
  }, [timeout]);

  
  const handleClose = () => {
    onCloseRef.current();
  };


  return (
    <SnackbarContent
        className={clsx(classes[variant])}
        aria-describedby="client-snackbar"
        message={
        <span id="client-snackbar" className={classes.message}>
            <Icon className={clsx(classes.icon, classes.iconVariant)} />
            {message}
        </span>
        }
        action={[
        <IconButton key="close" aria-label="close" color="inherit" onClick={handleClose}>
            <CloseIcon className={classes.icon} />
        </IconButton>,
        ]}
    />
  );
}
